module.exports = __webpack_public_path__ + "img/txt.e2b1333b.svg";